<template>
  <b-container class="create-program-container">
    <b-row>
      <b-col md="8">
        <b-row>
          <b-col md="12">
            <h2 class="float-left">{{ isEdit ? 'Hír szerkesztése' : 'Új hír hozzáadása' }}</h2>
          </b-col>
        </b-row>
        <b-row class="first-row">
          <b-col md="12"
            ><b-form-group id="news-name">
              <legend>Cím</legend>
              <b-form-input id="news-name" placeholder="" v-model="name" type="text" class="border inputFieldAlign">
              </b-form-input>
              <input-error :v-if="nameError.length > 0" :errors="[nameError]" />
            </b-form-group>
          </b-col>
          <template>
            <b-col md="6">
              <b-form-group>
                <legend>Megjelenés dátuma</legend>
                <b-form-datepicker
                  v-model="selectedDate"
                  locale="hu"
                  label-no-date-selected="Megjelenés dátuma"
                  reset-button
                  reset-value="null"
                  label-reset-button="Törlés"
                  label-help=""
                ></b-form-datepicker>
                <input-error :v-if="releaseDateError.length > 0" :errors="[releaseDateError]" />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <legend>Megjelenés ideje</legend>
                <b-form-timepicker
                  v-model="selectedTime"
                  locale="hu"
                  label-no-time-selected="Megjelenés ideje"
                  reset-button
                  :reset-value="null"
                  label-reset-button="Törlés"
                  label-help=""
                  label-close-button="Bezárás"
                ></b-form-timepicker>
              </b-form-group>
            </b-col>
          </template>
          <b-col md="12"
            ><b-form-group id="news-lead">
              <legend>Tartalmi összefoglaló - Lead</legend>
              <b-form-textarea
                id="news-lead"
                placeholder="A hír rövid tartalmi összefoglalója (max 200 karakter)"
                v-model="shortSummary"
                type="text"
                class="border inputFieldAlign"
              >
              </b-form-textarea>
              <input-error :v-if="shortSummaryError.length > 0" :errors="[shortSummaryError]" />
            </b-form-group>
          </b-col>
          <b-col md="12"
            ><b-form-group id="news-text">
              <legend>Tartalom</legend>
              <quill-editor v-model="newsText" ref="myQuillEditor" :options="editorOption"> </quill-editor>
              <input-error :v-if="newsTextError.length > 0" :errors="[newsTextError]" />
            </b-form-group>
          </b-col>
          <b-col md="12"
            ><b-form-group id="news-text">
              <legend>Forrás</legend>
              <b-form-input
                id="news-source"
                placeholder=""
                v-model="newsSource"
                type="text"
                class="border inputFieldAlign"
              >
              </b-form-input>
              <input-error :v-if="newsSourceError.length > 0" :errors="[newsSourceError]" />
            </b-form-group>
          </b-col>
        </b-row>

        <b-row class="mt-5">
          <b-col md="6">
            <b-button @click="save" variant="primary" class="save-button w-100">Mentés</b-button>
          </b-col>
        </b-row>
      </b-col>

      <b-col md="4" class="text-left">
        <!--<program-card :name="name" :code="code" :link="link" :status="status" color="green" />-->
        <label>Kép feltöltése</label>

        <template v-if="!newsImgUrl">
          <svg width="364" height="374" viewBox="0 0 364 374" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect y="21" width="364" height="273" rx="8" fill="#DFE6E9" />

            <path
              d="M132 134.143C132 130.922 133.317 127.834 135.661 125.557C138.005 123.279 141.185 122 144.5 122H219.5C222.815 122 225.995 123.279 228.339 125.557C230.683 127.834 232 130.922 232 134.143V194.857C232 198.078 230.683 201.166 228.339 203.443C225.995 205.721 222.815 207 219.5 207H144.5C141.185 207 138.005 205.721 135.661 203.443C133.317 201.166 132 198.078 132 194.857V134.143V134.143ZM138.25 188.786V194.857C138.25 196.467 138.908 198.012 140.081 199.15C141.253 200.289 142.842 200.929 144.5 200.929H219.5C221.158 200.929 222.747 200.289 223.919 199.15C225.092 198.012 225.75 196.467 225.75 194.857V173.607L202.144 161.786C201.558 161.501 200.894 161.402 200.247 161.503C199.6 161.605 199.002 161.901 198.537 162.351L175.35 184.876L158.725 174.117C158.125 173.729 157.405 173.554 156.687 173.623C155.969 173.692 155.298 173.999 154.787 174.494L138.25 188.786ZM169.5 149.321C169.5 146.906 168.512 144.59 166.754 142.882C164.996 141.174 162.611 140.214 160.125 140.214C157.639 140.214 155.254 141.174 153.496 142.882C151.738 144.59 150.75 146.906 150.75 149.321C150.75 151.737 151.738 154.053 153.496 155.761C155.254 157.469 157.639 158.429 160.125 158.429C162.611 158.429 164.996 157.469 166.754 155.761C168.512 154.053 169.5 151.737 169.5 149.321Z"
              fill="white"
            />
          </svg>
        </template>
        <template v-else>
          <img :src="newsImgUrl" class="w-100 mb-4" />
        </template>

        <input
          type="file"
          name="file"
          @change="
            filesChange($event.target.name, $event.target.files)
            fileCount = $event.target.files.length
          "
          accept="image/*"
          class="input-file mt-0"
          variant="secondary"
        />

        <input-error :v-if="newsImgError.length > 0" :errors="[newsImgError]" class="mt-2 mb-2" />

        <br /><br />

        <small>A kép mérete nem haladhatja meg a 12MB-ot. Elfogadott formátumok: RAW, JPEG, PNG</small>
        <b-form-group id="news-image-source" class="mt-2">
          <label>Kép címe és forrása</label>
          <b-form-input
            id="news-image-source"
            placeholder=""
            v-model="newsImgSource"
            type="text"
            class="border inputFieldAlign"
          >
          </b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { createNews, editNews, getNewsItem } from '../../api/news'
import api from '../../api/api'
import InputError from '../../components/InputError.vue'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'
const imgRetUrl = `${window._env_.VUE_APP_API_URL}/api/v1/cms-news/get-image/`

export default {
  name: 'CreateNews',
  components: {
    InputError,
    quillEditor
  },
  async created() {
    if (this.isEdit) {
      const newsItem = await getNewsItem(this.$route.query.id)
      this.name = newsItem.name
      this.shortSummary = newsItem.lead
      this.newsText = newsItem.body
      this.newsSource = newsItem.source
      this.newsImgUrl = `${newsItem.image}`
      this.releaseDate = newsItem.releaseDate
      this.selectedDate = newsItem.releaseDate.split('T')[0]
      this.selectedTime = newsItem.releaseDate.split('T')[1]
      this.releaseStatus = newsItem.status
      this.newsImgSource = newsItem.imageSource
    }
  },
  data() {
    return {
      name: '',
      shortSummary: '',
      newsText: '',
      newsImgUrl: '',
      newsImgSource: '',
      newsSource: '',
      nameError: '',
      shortSummaryError: '',
      newsTextError: '',
      newsImgError: '',
      newsImgSourceError: '',
      newsSourceError: '',
      releaseDateError: '',
      editorOption: {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            [{ header: 1 }, { header: 2 }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ indent: '-1' }, { indent: '+1' }],
            ['video', 'image']
          ]
        }
      },
      selectedDate: null,
      selectedTime: '12:00',
      releaseDate: '',
      releaseStatus: ''
    }
  },
  computed: {
    isEdit: function() {
      return !!this.$route.query.id
    },
    editor() {
      return this.$refs.myQuillEditor.quill
    },
    getNewsImage() {
      if (this.newsImgUrl != '') return `${imgRetUrl}${this.newsImgUrl}`
      else return ``
    },
    getSelectedDate() {
      if (this.selectedDate == '') return null
      if (this.selectedTime == null) return null
      else if (this.selectedDate != null && this.selectedTime != null)
        return new Date(this.selectedDate + ' ' + this.selectedTime)
      else return null
    }
  },
  methods: {
    resetValues() {
      this.name = this.shortSummary = this.newsText = this.newsImgSource = this.newsSource = ''
    },
    clearErrors() {
      this.nameError = this.shortSummaryError = this.newsTextError = this.newsImgSourceError = this.newsSourceError = this.newsImgError = this.newsSourceError =
        ''
    },
    async save() {
      try {
        this.clearErrors()
        let data = {
          name: this.name,
          lead: this.shortSummary,
          body: this.newsText,
          source: this.newsSource,
          image: this.newsImgUrl,
          imageSource: this.newsImgSource
        }

        if (this.getSelectedDate != null) data = { ...data, releaseDate: this.getSelectedDate }

        if (this.isEdit) {
          await editNews(data, this.$route.query.id)
        } else {
          await createNews(data)
          this.resetValues()
          this.$router.push('/contents/news')
        }
        this.$store.dispatch('notify', {
          newNotification: {
            type: 'success',
            message: this.isEdit ? 'Hír módosítása sikeres! ' : 'Hír hozzáadása sikeres!'
          }
        })
        if (this.isEdit) this.$router.push('/contents/news')
      } catch (e) {
        if (e.response && e.response.status === 400 && e.response.data && e.response.data.details) {
          const errors = e.response.data.details
          errors.forEach(error => {
            if (error.path.includes('name')) {
              this.nameError = error.message
            }
            if (error.path.includes('lead')) {
              this.shortSummaryError = error.message
            }
            if (error.path.includes('body')) {
              this.newsTextError = error.message
            }
            if (error.path.includes('source')) {
              this.newsSourceError = error.message
            }
            if (error.path.includes('releaseDate')) {
              this.releaseDateError = error.message
            }
            if (error.path.includes('image')) {
              this.newsImgError = error.message
            }
            if (error.path.includes('source')) {
              this.newsSourceError = error.message
            }
          })
        } else {
          this.$store.dispatch('notify', {
            newNotification: { type: 'danger', message: 'Hiba történt.' }
          })
          throw e
        }
      }
    },
    async saveImage(formData) {
      try {
        const savedImage = await api.post('/api/v1/cms-news/upload-image', formData)
        this.newsImgUrl = `${imgRetUrl}${savedImage.data.id}`
        this.$store.dispatch('notify', {
          newNotification: {
            type: 'success',
            message: 'Kép feltöltése sikeres!'
          }
        })
      } catch (err) {
        this.$store.dispatch('notify', {
          newNotification: {
            type: 'error',
            message: 'Kép feltöltése sikertelen!'
          }
        })
      }
    },
    async filesChange(fieldName, fileList) {
      // handle file changes
      const formData = new FormData()
      if (!fileList.length) return
      // append the files to FormData
      Array.from(Array(fileList.length).keys()).map(x => {
        formData.append(fieldName, fileList[x], fileList[x].name)
      })
      // save it
      await this.saveImage(formData)
    }
  }
}
</script>

<style scoped>
textarea {
  min-height: 10rem !important;
}
</style>
